export default "__VITE_ASSET__325c703b__"